import { Stack } from "@mui/material";
import { PopperWrapper } from "../Wrappers/PopperWrapper";

interface IFilterPanel {
  open: boolean;
  anchorEl: HTMLButtonElement | HTMLElement | null;
  onClose: (event: Event | React.SyntheticEvent) => void;
  children: React.ReactElement[];
}

export const FilterPanel: React.FC<IFilterPanel> = (props) => {
  const { open, anchorEl, onClose, children } = props;
  return (
    <PopperWrapper
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      popperProps={{
        open: open,
        sx: {
          width: {
            xs: "100%",
            sm: "500px",
          },
        },
      }}
      paperProps={{
        sx: {
          padding: 0,
          height: {
            xs: "450px",
            sm: "350px",
          },
        },
      }}
    >
      <Stack
        sx={{
          height: "100%",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
        }}
      >
        {children}
      </Stack>
    </PopperWrapper>
  );
};
